export enum ChangeViewText {
  ShowSwagger = 'Show Swagger',
  ShowTable = 'Show Table'
}
